var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReCopyClipboard"},[_c('base-button',{staticClass:"btn btn-icon no-border btn-simple btn-success my-0",on:{"click":_vm.copy}},[_c('i',{staticClass:"tim-icons icon-single-copy-04"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }